import React, { FunctionComponent, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router';

import { useFetchTokenMutation } from 'src/api/authentication-api/authentication-api';
import { Spinner } from 'src/components/spinner';
import { NavigationService } from 'src/services/navigation-service';
import { selectAuthState } from 'src/state/auth/selectors';
import { useAppSelector } from 'src/state/thunk-api';

export const AuthCallbackPage: FunctionComponent = () => {
  const location = useLocation();
  const authState = useAppSelector(selectAuthState);
  const [fetchToken, { isLoading }] = useFetchTokenMutation();

  const locationSearchParams = new URLSearchParams(location.search);
  const code = locationSearchParams.get('code');
  const state = locationSearchParams.get('state');

  useEffect(() => {
    if (!code || !state) {
      throw new Error('State or code parameter is missing');
    }

    if (authState.authenticationKey !== state) {
      throw new Error('Authentication key and state do not match');
    }

    if (!authState.codeVerifier) {
      throw new Error('Invalid state. No verifier found for challenge');
    }

    const body = {
      grant_type: 'authorization_code',
      code,
      redirect_uri: NavigationService.AUTH_REDIRECT_URL,
      code_verifier: authState.codeVerifier,
    };

    fetchToken(new URLSearchParams(body));
  }, [authState.authenticationKey, authState.codeVerifier, code, fetchToken, state]);

  if (isLoading) {
    return <Spinner />;
  }

  return <Navigate to={NavigationService.CHOOSE_ACCOUNT} replace={true} />;
};
